import axios, {AxiosPromise} from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IQueries } from '@/shared/model/queries.model';
import {IProduct} from "@/shared/model/product.model";

const baseApiUrl = 'api/queries';

export default class QueriesService {
  public find(id): Promise<IQueries> {
    return new Promise<IQueries>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any, search?: IQueries): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let url = `${baseApiUrl}?`;

      if (search.id != undefined) {
        url = `${url}id.equals=${search.id}&`;
      }

      if (search.queries != undefined) {
        url = `${url}queries.contains=${search.queries}&`;
      }

      if (search.product != undefined) {
        url = `${url}product.contains=${search.product}&`;
      }

      if (search.reporter != undefined) {
        url = `${url}reporter.contains=${search.reporter}&`;
      }

      if (search.processed != undefined) {
        url = `${url}processed.equals=${search.processed}&`;
      }

      if (search.alias != undefined) {
        url = `${url}alias.contains=${search.alias}&`;
      }

      if (search.description != undefined) {
        url = `${url}description.contains=${search.description}&`;
      }

      if (search.search) {
        url = `${url}search.contains=${search.search}&`;
      }
      axios.get(url + `${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  public delete(id): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity): Promise<IQueries> {
    return new Promise<IQueries>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      }).catch(param=> {
        resolve(param.response.data);
      }) ;
    });
  }

  public update(entity): Promise<IQueries> {
    return new Promise<IQueries>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      }).catch(param=> {
        resolve(param.response.data);
      });
    });
  }

  public query(req: any): Promise<any> {
      return new Promise(resolve => {
          axios
              .get(`${baseApiUrl}?
              processed=${req.processed}&
              product=${req.product}&
              alias=${req.alias}&
              reporter=${req.reporter}&
              ${buildPaginationQueryOpts(req)}`)
              .then(res => resolve(res));
      });
  }

  public retrieveQueriesRequest(search: string) : Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `/xpath?search=${search}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public downloadXpathReportAsCVS(id): AxiosPromise<any> {
    return axios.get(`${baseApiUrl}/download?queryId=${id}`);
  }
}
